// extracted by mini-css-extract-plugin
export default {"wrapper":"mC-z","viewport":"nC-z","container":"oC-z","slide":"pC-z"};